import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { Card, CardBody, CardHeader, Stack, Text } from "@chakra-ui/react";

import { selectActiveProperties } from "../../../redux/user/userSlice";
import { getPropertyAddress } from "../../../utils/verifier";

import PropertyCustomOwnerPlansCard from "./PropertyCustomOwnerPlansCard";

export default function CustomOwnerPlans() {
	const properties = useSelector(selectActiveProperties);
	const customOwnerPlansAvailable = useSelector((state) => state.user.user?.customOwnerPlans);
	const { t } = useTranslation();
	return (
		<Stack>
			<Card>
				<CardHeader>
					<Text fontSize="xl" fontWeight="bold">
						{t("navbarMenu.customOwnerPlans")}
					</Text>
				</CardHeader>
				<CardBody>
					<Text>
						Selectati pachetele de servicii dorite pentru fiecare proprietate. Acestea se vor adauga automat la valoarea comisionului de administrare lunar
						aferent proprietatii.
					</Text>
				</CardBody>
			</Card>
			{properties.map((property, index) => (
				<PropertyCustomOwnerPlansCard
					address={getPropertyAddress(property)}
					propertyId={property.id}
					customOwnerPlans={property.customOwnerPlans || []}
					customOwnerPlansAvailable={customOwnerPlansAvailable}
					key={index}
				/>
			))}
			{customOwnerPlansAvailable.length === 0 && (
				<Card>
					<CardBody>
						<Text>Nu exista pachete de servicii disponibile. Va rugam sa contactati administratorul pentru mai multe informatii.</Text>
					</CardBody>
				</Card>
			)}
		</Stack>
	);
}
